"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var color = function color(props) {
  if (props === void 0) {
    props = {};
  }

  var styles = {};

  if (props.fg) {
    styles.color = props.fg;
  }

  if (props.bg) {
    styles['background-color'] = props.bg;
  }

  return styles;
};

exports.default = color;